module.exports = __webpack_public_path__ + "beb8f0cb326086b90255913ada548214.pdf";